import { Link } from "react-router-dom";
import { C } from "../../constants/theme";
import FadeIn from "../ui/FadeIn";
import RainbowDivider from "../ui/RainbowDivider";

const ForMothers = () => (
  <section id="for-mothers" style={{ background:C.navy, padding:"100px 6vw", position:"relative", overflow:"hidden" }}>
    <div style={{
      position:"absolute", inset:0,
      background:"radial-gradient(ellipse at 0% 100%, rgba(75,174,149,0.15) 0%, transparent 50%)",
      pointerEvents:"none",
    }}/>
    <div style={{ maxWidth:1100, margin:"0 auto", position:"relative" }}>
      <FadeIn>
        <div style={{ textAlign:"center", marginBottom:48 }}>
          <div style={{
            display:"inline-flex", alignItems:"center", gap:8,
            background:`linear-gradient(135deg, ${C.coral}, ${C.yellow})`,
            color:C.white, fontFamily:"Nunito", fontWeight:800,
            fontSize:11, letterSpacing:"0.14em", padding:"7px 16px",
            borderRadius:100, textTransform:"uppercase", marginBottom:18,
          }}>
            ✦ The First Of Its Kind ✦
          </div>
          <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(26px,4vw,46px)", color:C.white, margin:"0 0 16px", lineHeight:1.15 }}>
            The First School Ever<br/>
            <span style={{color:C.yellow}}>Where Mothers Stay With Their Children.</span>
          </h2>
          <RainbowDivider />
          <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(15px,2vw,18px)", color:"rgba(255,255,255,0.82)", maxWidth:680, margin:"0 auto 16px", lineHeight:1.8 }}>
            In every other preschool, the mother's role ends at the gate.
            <br/>At Mini Muslims Nest, <b style={{ color:C.yellow, fontStyle:"normal", fontWeight:700 }}>the gate is the beginning</b>.
          </p>
          <p style={{ fontFamily:"Nunito", fontSize:14.5, color:"rgba(255,255,255,0.65)", maxWidth:620, margin:"0 auto", lineHeight:1.8 }}>
            You walk in with your child. You sit in the same building. You learn while they learn. You leave with them — different from the woman who walked in. This is not a service. It is a journey we take together.
          </p>
        </div>
      </FadeIn>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:16 }}>
        {[
          { icon:"📖", color:C.yellow, title:"Friday Halaqa" },
          { icon:"💆", color:C.coral, title:"Parent Coaching" },
          { icon:"🤝", color:C.mint, title:"The Mother Circle" },
          { icon:"🌱", color:"#8B6BE8", title:"HT4 Framework" },
        ].map(({ icon, color, title }) => (
          <FadeIn key={title} delay={0.08}>
            <div style={{
              background:"rgba(255,255,255,0.06)", border:`1.5px solid rgba(255,255,255,0.1)`,
              borderRadius:16, padding:"20px 18px", textAlign:"center",
            }}>
              <div style={{ fontSize:26, marginBottom:10 }}>{icon}</div>
              <div style={{ fontFamily:"Fredoka One", fontSize:15, color, lineHeight:1.3 }}>{title}</div>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.15}>
        <div style={{ textAlign:"center", marginTop:32 }}>
          <Link to="/for-mothers" style={{
            background:C.yellow, color:C.navy, textDecoration:"none",
            fontFamily:"Nunito", fontWeight:800, fontSize:14,
            padding:"13px 30px", borderRadius:100, display:"inline-block",
          }}>See a Day in the Life →</Link>
        </div>
      </FadeIn>
    </div>
  </section>
);

export default ForMothers;
